export const DocumentType = {
  w9: 'W-9',
  partnerReferralAgreement: 'Partner Referral Agreement',
  other: 'Other',
} as const;

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

export class Document {
  public id: string;
  public name: string;
  public type: DocumentType;

  constructor(id: string, name: string, type: DocumentType) {
    this.id = id;
    this.name = name;
    this.type = type;
  }
}

export type UploadUrl = string;
